import React from 'react';

const SnakeShape3 = ({ className }) => {
  return (
    <svg 
      className={className}
      width="391" 
      height="681" 
      viewBox="0 0 391 681" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M5.84758 -89.2062C1.19961 -50.8192 -3.89965 -4.52382 27.0424 44.1513C73.8436 117.774 137.959 127.507 224.384 162.947C279.012 185.348 363.759 198.898 385.053 257.618C396.048 287.937 375.115 310.312 361.753 331.284C340.689 364.346 322.525 393.372 304.876 431.776C297.036 448.835 210.305 684.975 304.876 768.035" 
        stroke="#EFBE74" 
        stroke-width="4.5"
      />
    </svg>
  );
};

export default SnakeShape3;
